/**
 * Select domain
 */
export const selectAppDomain = (state) => state.app;